import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.215 7.545 5.073 4.329 4.52-5.397c.127-.15.287-.272.468-.355a1.37 1.37 0 0 1 1.159.013c.18.086.336.21.46.364l4.313 5.373 5.237-4.39a1.368 1.368 0 0 1 1.512-.155c.238.126.43.32.552.556.122.236.166.502.127.762l-2 13.378H5.046L3.014 8.706c-.04-.262.003-.53.125-.767s.316-.433.556-.56a1.369 1.369 0 0 1 1.519.166ZM5.15 23.316h21.333v1.293c0 .343-.14.672-.39.914-.251.243-.59.379-.944.379H6.483c-.354 0-.693-.136-.943-.379a1.273 1.273 0 0 1-.39-.914v-1.293Z",
    stroke: "currentColor"
  })));
};

var SvgCrown = styled(SvgComponent).withConfig({
  displayName: "Crown__SvgCrown",
  componentId: "sc-tjxt9h-0"
})(["", " ", ""], size, color);
export default SvgCrown;